// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Skeleton from "@awc/App/Components/Skeleton/Skeleton";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

type Props = OwnProps;

export interface ProductListFiltersAccordionStyles {
    accordion?: AccordionPresentationProps;
}

export const filtersAccordionStyles: ProductListFiltersAccordionStyles = {
    accordion: {
        css: css`
            padding-top: 20px;
        `,
    },
};

const styles = filtersAccordionStyles;

const ProductListFiltersAccordion: FC<Props> = ({ id }) => {
    // <XNG-Changes>
    const isLoading = useAppSelector(state => state.pages.productList.isLoading);
    if (isLoading) {
        return <Skeleton isLoading={true} height="300px" />;
    }
    // </XNG-Changes>
    return (
        <Accordion headingLevel={2} {...styles.accordion}>
            <Zone contentId={id} zoneName="Content" />
        </Accordion>
    );
};

const widgetModule: WidgetModule = {
    component: ProductListFiltersAccordion,
    definition: {
        group: "Product List",
        displayName: "Filters Accordion",
        // XNG-Changes: add CategoryDetailsPage
        allowedContexts: ["ProductListPage", "CategoryDetailsPage"],
    },
};

export default widgetModule;
